import { ChevronDown } from "lucide-react";
import OutlineImageWithFallback from "@/shared/components/outline-image-with-fallback/outline-image-with-fallback";

interface ProductCollapseRowProps {
  productName: string;
  productLogo?: string;
  progressCurrent: number;
  progressTotal: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export default function ProductCollapseRow({
  productName,
  productLogo,
  progressCurrent,
  progressTotal,
  isExpanded,
  onToggle,
}: ProductCollapseRowProps) {
  return (
    <div
      className="bg-[#f8fafc] border-b border-border flex items-center pl-[28px] pr-0 py-0 h-[40px] cursor-pointer"
      onClick={onToggle}
    >
      {/* Collapse Button */}
      <div className="flex items-center justify-center h-full w-[45px] shrink-0">
        <div className="flex items-center justify-center size-8">
          <ChevronDown
            className={`w-4 h-4 text-foreground transition-transform duration-200 ${
              isExpanded ? "rotate-0" : "-rotate-90"
            }`}
          />
        </div>
      </div>

      {/* Product Logo and Name */}
      <div className="flex items-center gap-2 pr-3">
        <OutlineImageWithFallback
          src={productLogo || ""}
          alt={productName}
          name={productName}
          containerSize={24}
          imageSize={17}
          className="shrink-0"
        />
        <p className="text-[12px] font-600 text-foreground leading-4 whitespace-nowrap">
          {productName}
        </p>
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Progress Indicator */}
      <div className="flex items-center gap-2 px-4 h-full shrink-0">
        <p className="text-[12px] font-500 text-muted-foreground leading-4 whitespace-nowrap">
          {progressCurrent}/{progressTotal}
        </p>
        <div className="relative size-4 shrink-0">
          <svg
            className="w-4 h-4"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8"
              cy="8"
              r="6"
              fill="none"
              stroke="#e4e4e7"
              strokeWidth="2"
            />
            <circle
              cx="8"
              cy="8"
              r="6"
              fill="none"
              stroke="#16a34a"
              strokeWidth="2"
              strokeDasharray={`${
                (progressCurrent / progressTotal) * 37.7
              } 37.7`}
              strokeLinecap="round"
              transform="rotate(-90 8 8)"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
